import React from 'react';
import ResultPageModal, { capitalizeTitle } from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function InfortunioModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  type,
  processingQuote,
}) {
  let title = type.id === 'res_civile' && insuranceRequest.product.id === 1002
    ? 'Morte da Infortunio'
    : capitalizeTitle(type.name);
  if (insuranceRequest.product.id === 1002 && type.id === 'estensione_nucleo_famigliare') {
    title = `${title} (Massimo 3 componenti)`;
  }

  return (
    <ResultPageModal
      type={type}
      title={title}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
      matchByCode
    />
  );
}

export default InfortunioModal;
